import $ from "jquery";

function tabs(cls,el,mobile = false,cls2) {
    let files_content = $('[data-toggle-content=' + el.data('toggle-trigger') +']'),
        trigger = $('[data-toggle-trigger=' + el.data('toggle-trigger') +']');

    if(mobile === true) {
        el.addClass(cls).parent().siblings().children().removeClass(cls);
        $('.data-menu').find(trigger).addClass(cls2).siblings().removeClass(cls2);
        $('.append-title').text(el.text())
    } else {
        el.addClass(cls).siblings().removeClass(cls);
        $('.dropdown-menu').find(trigger).addClass(cls2).parent().siblings().children().removeClass(cls2)
        $('.append-title').text(el.text())
    }

    (el.hasClass(cls)) ? files_content.addClass('active').siblings().removeClass('active') : console.log('not working');
}

$('.data-menu__item').click(function() {
    tabs('current-menu-item',$(this),false,'data-dropdown__menu-link--active')

    $('.data-search__output').attr('data-active-index', $(this).attr('data-index'))
});

$('.data-dropdown__menu-link').click(function() {
    tabs('data-dropdown__menu-link--active',$(this),true,'current-menu-item')
});